import * as React from 'react';
import { useParams } from 'react-router-dom';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import MeetingActivityPageView from '../features/activities/MeetingActivityPageView';

export default function WorkgroupMeetingPage(): JSX.Element {
    
    const params = useParams<{ activityId: string }>();
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="workgroupmeeting">
            {params.activityId 
                ? <MeetingActivityPageView activityId={params.activityId} />
                : <span>ugyldig url</span>
        }
        </ProtectedPageWrapper>
    );
}
